import React from 'react'

import PropTypes from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import Loader from '../Loader'
import UserBox from './UserBox'

function UserResults({
  users,
  scope,
  selectedUsers = EMPTY_ARRAY,
  selectUser,
  showLoader = false,
  isEmail = false,
  updateActiveUser,
  cursorPosition,
}) {
  const keyName = navigator.platform.toUpperCase().indexOf('MAC') >= 0 ? 'Return' : 'Enter'

  return (
    <div className="user-search__results card">
      {showLoader ? (
        <div className="user-search__empty-container">
          <Loader />
        </div>
      ) : (
        users.length > 0 ? (
          users.map((user, i) => {
            const userCheck = selectedUsers.filter(newUser => newUser.id === user.attributes.id)

            return (
              <UserBox
                key={user.attributes.id}
                attributes={user.attributes}
                selectUser={selectUser}
                isDisabled={userCheck.length > 0}
                isActive={cursorPosition === i}
                updateActiveUser={updateActiveUser}
                scope={scope}
              />
            )
          })
        ) : (
          isEmail ? (
            <div className="user-search__empty-container">
              Hit <span className="text-semibold">{keyName}</span> to select email
            </div>
          ) : (
            <div className="user-search__empty-container">
              No Users found, please try again
            </div>
          )
        )
      )}
    </div>
  )
}

UserResults.propTypes = {
  users: PropTypes.array.isRequired,
  scope: PropTypes.string.isRequired,
  selectedUsers: PropTypes.array,
  selectUser: PropTypes.func.isRequired,
  showLoader: PropTypes.bool,
  isEmail: PropTypes.bool,
  updateActiveUser: PropTypes.func.isRequired,
}

export default UserResults
